<template>
  <div>
    <div v-if="isFilterApplied" class="d-flex justify-content-end mb-3">
      <a
        href="javascript:;"
        class="btn btn-secondary w-60 display-6"
        @click="handleClearFilters"
      >
        Clear Filters
      </a>
    </div>
  </div>
  <form @submit.prevent="handleFilters">
    <div class="row filter-row">
      <div class="col-sm-6 col-md-2 position-relative">
        <div class="input-block mb-3 form-focus select-focus">
          <vue-select
            :options="jobs"
            v-model="filters.job_name"
            placeholder="Select Job Title"
            id="design3"
          />
          <label class="focus-label">Job Title</label>
        </div>
        <i
          v-if="filters.job_name"
          @click="handleClearOneFilter('job_name')"
          class="fa-solid fa-x"
          :style="{
            position: 'absolute',
            top: '-20px',
            right: '0px',
            cursor: 'pointer',
          }"
        ></i>
      </div>
      <div class="col-sm-6 col-md-2 position-relative">
        <div class="input-block mb-3 form-focus select-focus">
          <vue-select
            :options="genders"
            v-model="filters.gender_id"
            placeholder="Select Gender"
          />
          <label class="focus-label">Gender</label>
        </div>
        <i
          v-if="filters.gender_id"
          @click="handleClearOneFilter('gender_id')"
          class="fa-solid fa-x"
          :style="{
            position: 'absolute',
            top: '-20px',
            right: '0px',
            cursor: 'pointer',
          }"
        ></i>
      </div>
      <div class="col-sm-6 col-md-2 position-relative">
        <div class="input-block mb-3 form-focus select-focus">
          <vue-select
            :options="locations"
            v-model="filters.apply_location"
            placeholder="Select Location"
          />
          <label class="focus-label">Location</label>
        </div>
        <i
          v-if="filters.apply_location"
          @click="handleClearOneFilter('apply_location')"
          class="fa-solid fa-x"
          :style="{
            position: 'absolute',
            top: '-20px',
            right: '0px',
            cursor: 'pointer',
          }"
        ></i>
      </div>
      <div class="col-sm-6 col-md-2 position-relative">
        <div class="input-block mb-3 form-focus select-focus">
          <vue-select
            :options="areas"
            v-model="filters.area"
            placeholder="Select Area"
          />
          <label class="focus-label">Area</label>
        </div>
        <i
          v-if="filters.area"
          @click="handleClearOneFilter('area')"
          class="fa-solid fa-x"
          :style="{
            position: 'absolute',
            top: '-20px',
            right: '0px',
            cursor: 'pointer',
          }"
        ></i>
      </div>
      <div class="col-sm-6 col-md-2 position-relative">
        <div class="input-block mb-3 form-focus select-focus">
          <vue-select
            :options="experiences"
            v-model="filters.experience"
            placeholder="Select Experience"
          />
          <label class="focus-label">Experience</label>
        </div>
        <i
          v-if="filters.experience"
          @click="handleClearOneFilter('experience')"
          class="fa-solid fa-x"
          :style="{
            position: 'absolute',
            top: '-20px',
            right: '0px',
            cursor: 'pointer',
          }"
        ></i>
      </div>
      <div class="col-sm-6 col-md-2">
        <div
          class="input-block mb-3 form-focus"
          :class="{ focused: isFocusedApplicantId }"
        >
          <input
            type="text"
            class="form-control floating"
            v-model="filters.applicant_id"
            @focus="isFocusedApplicantId = true"
            @blur="isFocusedApplicantId = applicant_id !== ''"
          />
          <label class="focus-label">Applicant Id</label>
        </div>
      </div>
      <div class="col-sm-6 col-md-2">
        <div
          class="input-block mb-3 form-focus"
          :class="{ focused: isFocusedFirstName }"
        >
          <input
            type="text"
            class="form-control floating"
            v-model="filters.first_name"
            @focus="isFocusedFirstName = true"
            @blur="isFocusedFirstName = first_name !== ''"
          />
          <label class="focus-label">First Name</label>
        </div>
      </div>
      <div class="col-sm-6 col-md-2">
        <div
          class="input-block mb-3 form-focus"
          :class="{ focused: isFocusedLastName }"
        >
          <input
            type="text"
            class="form-control floating"
            v-model="filters.last_name"
            @focus="isFocusedLastName = true"
            @blur="isFocusedLastName = last_name !== ''"
          />
          <label class="focus-label">Last Name</label>
        </div>
      </div>
      <div class="col-sm-6 col-md-2">
        <div
          class="input-block mb-3 form-focus"
          :class="{ focused: isFocusedCnic }"
        >
          <input
            type="text"
            class="form-control floating"
            v-model="filters.cnic"
            @focus="isFocusedCnic = true"
            @blur="isFocusedCnic = cnic !== ''"
          />
          <label class="focus-label">CNIC</label>
        </div>
      </div>
      <div class="col-sm-6 col-md-2">
        <div
          class="input-block mb-3 form-focus"
          :class="{ focused: isFocusedDate }"
        >
          <input
            type="date"
            class="form-control floating"
            v-model="filters.date"
            @focus="isFocusedDate = true"
            @blur="isFocusedDate = date !== ''"
          />
          <label class="focus-label" style="top: -20px">Applied Date</label>
        </div>
      </div>

      <div class="col-9"></div>
      <div class="d-flex mb-2 col-sm-6 col-md-3 gap-2">
        <button
          type="button"
          class="btn btn-success w-100"
          @click.prevent="handleFilters"
        >
          Search
        </button>
        <button
          type="button"
          href="javascript:;"
          class="btn btn-success w-100"
          @click.prevent="resetAllFilters"
        >
          Reset
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import RecruitmentRequisitionService from "@/services/RecruitmentRequisitionService";
import GenderService from "@/services/GenderService";
import CityService from "@/services/CityService";
import ExperienceService from "@/services/ExperienceService";
import AreaService from "@/services/AreaService";

export default {
  data() {
    return {
      select2: null,
      //   Company: ["Select Company", "Global Technologies", "Delta Infotech"],
      isFocused: false,
      filters: {
        applicant_id: "",
        job_name: "",
        first_name: "",
        last_name: "",
        cnic: "",
        date: "",
        gender_id: "",
        apply_location: "",
        area: "",
        experience: "",
      },
      jobs: [],
      genders: [],
      locations: [],
      areas: [],
      experiences: [],
      isFocusedOn: false,
      isFocusedApplicantId: false,
      isFocusedFirstName: false,
      isFocusedLastName: false,
      isFocusedJobName: "",
      isFocusedCnic: "",
      isFocusedDate: "",
      //   isFocusedEmail: "",
      //   isFocusedPsuedoName: "",
      //   isFocusedEmpStatus: "",
      //   selectedDesignation: "",
      //   employmentStatuses: [],
      //   departments: [],
      //   divisions: [],
      //   campaigns: [],
      //   projects: [],
      //   sections: [],
      //   designations: [],
      searched: false,
    };
  },
  props: {},
  methods: {
    handleFilters(value) {
      //console.log(JSON.stringify(this.filters));
      this.searched = true;
      this.$emit("apply-filters", this.filters);
      // Perform any action on change
    },

    async fetchJobs() {
      try {
        const response = await RecruitmentRequisitionService.fetch();
        this.jobs = response?.data
          .filter((el) => el.status == "publish")
          .map((e) => e.job_title);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      }
    },
    async fetchGenders() {
      try {
        const response = await GenderService.getGenders();
        this.genders = response?.data.map((e) => e.gender_name);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      }
    },
    async fetchLocations() {
      try {
        const response = await CityService.getCities();
        this.locations = response?.data.map((e) => e.city_name);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      }
    },
    async fetchAreas() {
      try {
        const response = await AreaService.fetch();
        this.areas = response?.data.map((e) => e.area);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      }
    },
    async fetchExperiences() {
      try {
        const response = await ExperienceService.fetch();
        this.experiences = response?.data.map((e) => e.experience);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      }
    },

    handleClearOneFilter(fileName) {
      this.filters[fileName] = "";
      const filtersHasProperty = Object.values(this.filters).filter(
        (el) => !!el
      ).length;
      if (this.searched) {
        this.$emit("apply-filters", this.filters);
      }
      if (!filtersHasProperty) {
        this.searched = false;
      }
    },

    resetAllFilters() {
      // Reset all filter values to empty strings
      Object.keys(this.filters).forEach((key) => {
        this.filters[key] = "";
      });

      // Emit updated filters
      this.$emit("apply-filters", this.filters);

      // Reset search state
      this.searched = false;
    },

    handleClearFilters() {
      this.$emit("apply-filters", {});
      this.filters = {
        applicant_id: "",
        job_name: "",
        first_name: "",
        last_name: "",
        cnic: "",
        date: "",
        gender_id: "",
        apply_location: "",
        area: "",
        experience: "",
      };
      this.searched = false;
    },
  },
  async created() {
    this.searched = false;
    await this.fetchJobs();
    await this.fetchGenders();
    await this.fetchLocations();
    await this.fetchAreas();
    await this.fetchExperiences();
    // this.fetchEmploymentStatuses();
    // this.designations = (await DesignationService.getDesignations())?.data.map(
    //   (el) => el.designation_name
    // );
    // this.divisions = (await DivisionService.getDivisions())?.data.map(
    //   (el) => el.name
    // );
    // this.departments = (await DepartmentService.getDepartments())?.data.map(
    //   (el) => el.name
    // );
    // this.campaigns = (await CampaignService.getCampaigns())?.data.map(
    //   (el) => el.campaigns
    // );
    // this.projects = (await EmployeeProjectService.fetch())?.data.map(
    //   (el) => el.project_name
    // );
    // this.sections = (await SectionService.getSections())?.data.map(
    //   (el) => el.section_name
    // );

    // through ID
    // this.designations = (await DesignationService.getDesignations()).data.map(el => ({id: el.id, text: el.designation_name}));
    // this.divisions = (await DivisionService.getDivisions()).data.map(el => ({id: el.id, text:el.name}));
    // this.departments = (await DepartmentService.getDepartments()).data.map(el => ({id: el.id, text:el.name}));
    // this.campaigns = (await CampaignService.getCampaigns()).data.map(el => ({id:el.id, text: el.campaigns}));
    // this.sections = (await SectionService.getSections()).data.map(el => ({id: el.id, text: el.section_name}));
  },

  computed: {
    isFilterApplied() {
      const filtersHasProperty = Object.values(this.filters).filter(
        (el) => !!el
      ).length;

      return this.searched && filtersHasProperty;
    },
  },
};
</script>
